import React from 'react';
import { getApiUrlComponents, toHookName } from '../../apis-infra';
import { useApisClientContext, useQueryOptionsContext } from '../Providers';
import { createApiQuery } from './createApiQuery';
import { getQueryClientDefaultQueryOptions } from './queryClientInstance';
import { mergeQueryOptions } from './internal';
export const createApiFetchHook = _ref => {
  let {
    methodConfig
  } = _ref;
  const fetchQuery = createApiQuery({
    methodConfig
  });
  const useFetch = function (props) {
    if (props === void 0) {
      props = {};
    }
    const {
      options: propsOptions,
      ignoreQueryContext
    } = props;
    const {
      queryOptions: contextOptions,
      hooksOnly
    } = useQueryOptionsContext();
    const {
      httpClient
    } = useApisClientContext();
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const isMountedRef = React.useRef(false);
    const options = React.useMemo(() => mergeQueryOptions(hooksOnly || ignoreQueryContext ? {} : contextOptions, propsOptions), [contextOptions, propsOptions, hooksOnly]);
    React.useEffect(() => {
      isMountedRef.current = true;
      return () => {
        isMountedRef.current = false;
      };
    }, []);
    React.useEffect(() => {
      if (error) {
        var _options$onError, _options$useErrorBoun;
        const queryClientOptions = getQueryClientDefaultQueryOptions();
        const onError = (_options$onError = options == null ? void 0 : options.onError) != null ? _options$onError : queryClientOptions.onError;
        const useErrorBoundaryOption = (_options$useErrorBoun = options == null ? void 0 : options.useErrorBoundary) != null ? _options$useErrorBoun : queryClientOptions.useErrorBoundary;
        const throwToBoundary = typeof useErrorBoundaryOption === 'boolean' ? useErrorBoundaryOption : false;
        const errorBoundaryCB = typeof useErrorBoundaryOption === 'function' ? useErrorBoundaryOption : undefined;
        onError == null ? void 0 : onError(error);
        if (throwToBoundary || errorBoundaryCB != null && errorBoundaryCB(error, {
          queryKey: getApiUrlComponents(methodConfig)
        })) {
          throw error;
        }
      }
    }, [error]);
    const query = React.useCallback(async (request, fallback) => {
      try {
        setIsLoading(true);
        const data = await fetchQuery({
          httpClient,
          request,
          options
        });
        if (isMountedRef.current) {
          setError(undefined);
          setIsLoading(false);
        }
        options == null ? void 0 : options.onSuccess == null ? void 0 : options.onSuccess(data);
        options == null ? void 0 : options.onSettled == null ? void 0 : options.onSettled(data, undefined);
        return {
          data
        };
      } catch (err) {
        if (isMountedRef.current) {
          fallback == null && setError(err);
          setIsLoading(false);
        }
        options == null ? void 0 : options.onError == null ? void 0 : options.onError(err);
        options == null ? void 0 : options.onSettled == null ? void 0 : options.onSettled(fallback, err);
        return {
          data: fallback,
          error: err
        };
      }
    }, [setIsLoading, setError, fetchQuery]);
    return {
      query,
      isLoading,
      error,
      isError: !!error
    };
  };
  return useFetch;
};
export const createApiFetchHooks = _ref2 => {
  let {
    apiConfig
  } = _ref2;
  return Object.keys(apiConfig).reduce((acc, methodName) => {
    const methodConfig = apiConfig[methodName];
    return {
      ...acc,
      [toHookName(methodName)]: createApiFetchHook({
        methodConfig
      })
    };
  }, {});
};
//# sourceMappingURL=createApiFetchHook.js.map